import React from 'react';

import { Skeleton } from '@material-ui/lab';
import { StyledAvatar } from 'components/avatars';
import styled, { css } from 'styled-components';
import { StyledPaper } from 'styles/common';

export const MeshlistSkeleton = () => (
  <div>
    <StyledPaper elevation={0} showBorder padding="1.5rem 1rem">
      <Skeleton variant="rect" height={40} />
      <Skeleton variant="rect" height={40} style={{ marginTop: '1.5rem' }} />
      <Skeleton variant="rect" height={40} style={{ marginTop: '1.5rem' }} />
    </StyledPaper>
  </div>
);

export const HeaderSkeleton = () => (
  <StyledPaper elevation={0} showBorder flexcontainer padding="1rem 1.5rem">
    <Skeleton variant="circle" height={60} width={60} />
    <Skeleton variant="text" style={{ marginLeft: '2rem', flex: 1 }} />
  </StyledPaper>
);

export const OneOnOneTileSkeleton = () => (
  <>
    <StyledPaper elevation={0} showBorder topGutter={3} padding="1.5rem 1.5rem 1rem 1.5rem">
      <Skeleton variant="rect" height={24} />
    </StyledPaper>
    <StyledPaper elevation={0} showBorder padding="1rem 1.5rem">
      <Skeleton variant="rect" height={24} />
    </StyledPaper>
    <StyledPaper elevation={0} showBorder padding="1rem 1.5rem 1.5rem 1.5rem">
      <Skeleton variant="rect" height={24} />
    </StyledPaper>
  </>
);

export const BorderAvatar = styled(StyledAvatar)`
  border: ${(props) => `1px solid ${props.theme.palette.borders.lighterGrey}`};
  filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.11));
  ${({ showBorder, theme }) =>
    showBorder &&
    css`
      border: 2px solid ${theme.palette.green.main};
      background-color: ${theme.palette.green.main};
    `}
  box-sizing: border-box;
`;
